export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('startGuideTemplates', (tabs) => {
        return {
          activeTab: '',
          tabs: tabs || [],
          init() {
            this.activeTab = tabs[0]?.id;
          },
          getTab(id) {
            window.scrollTo({ top: 0 });
            return (this.activeTab = id);
          },
          displayTab(id) {
            return this.activeTab === id;
          },
        };
      });
    });
  },
};
